<template>
    <div>
        <div style="text-align: center">
            <h3>Rules Stop AI</h3>
        </div>
        <br />
        <form v-on:submit.prevent="saveRule">
            <label>Keyword</label>
            <select name="keyword" v-model="form.keyword" class="form-control">
                <option selected="selected" value="or">Jika nilai di bawah memenuhi kondisi "ATAU" (OR)</option>
                <option value="and">Jika nilai di bawah memenuhi kondisi "DAN" (AND)</option>
            </select>
            <br />
            <div class="table-responsive rounded-3 shadow-sm">
                <table class="table mb-0">
                    <thead class="table-light">
                        <tr>
                            <th class="border-0">Kondisi</th>
                            <th class="border-0">Nilai</th>
                            <th class="border-0 text-center" width="80"></th>
                        </tr>
                    </thead>
                    <tbody class="parents-keywords-conditions">
                        <tr class="child-keywords-conditions" v-for="(rule, index) in rules" :key="index">
                            <td class="align-middle">
                                <select role="button"
                                    class="form-control" v-model="rule.condition">
                                    <option value="" disabled selected>-- Pilih Kondisi --</option>
                                    <option  value="equals">Pesan Sama
                                        Dengan</option>
                                    <option value="contains">Pesan Mengandung</option>
                                    <option value="not_equals">Pesan Tidak Sama
                                        Dengan</option>
                                    <option value="not_contains">Pesan Tidak
                                        Mengandung</option>
                                </select>
                            </td>
                            <td class="align-middle">
                                <input type="text" v-model="rule.value" class="form-control"
                                    placeholder="Ex: Minat kak">
                            </td>
                            <td>
                                <button v-on:click="deleteRule(index)"
                                    style="width: 40px; height: 40px; border-radius: 50%; border: none; color: white; 
                                    display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 16px;"
                                    class=" btn-danger" type="button">
                                    <i class="fa-solid fa-times"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-success btn-sm btn-block mt-1" @click="addRule" type="button">Tambah
                    Kondisi</button>
            </div>
            <br />
            <div class="button-group d-flex pt-25">
                <button type="submit"
                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                    simpan
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        id: {
            type: String,
            default: ""
        },
        keyword: {
            type: String,
            default: ""
        },
        condition: {
            type: Array,
        }
    },
    data() {
        return {
            devices: [],
            form: {
                keyword: "or",
                variable: [],
            },
            rules: [],
            null_value: null
        };
    },
    mounted() {

        // console.log("Id", this.id)
        // console.log("Keyword", this.keyword)
        // console.log("Condition", this.condition)

        if(this.keyword == ""){
            this.form.keyword = "or"
        }else{
            this.form.keyword = this.keyword
        }

        if(this.condition != null){
            this.rules = this.condition
        }else{
            this.rules = []
        }
        // this.getDevice()
        // this.getRules()
    },
    methods: {
        toggleModal(param) {
            this.$modal.show(param);
        },
        addRule() {
            this.rules.push({
                condition: "equals",
                value: ""
            });
        },
        deleteRule(index) {
            this.rules.splice(index, 1)
        },
        async saveRule() {
            try {
                let rules = {
                    id: this.id,
                    keyword: this.form.keyword,
                    conditions: this.rules
                }

                let response = await this.$store.dispatch('chatgpt_rule_create_or_update', rules)

                this.$toast.success(response.data.message)
                // this.getRules()

                //close modal
                this.$root.$emit("toggle_modal", "rules")
                this.$root.$emit("refresh_rules", "true")
            } catch (err) {
                this.$toast.error(err.response.data.message);
            }
        },
    },
};
</script>